module.exports = __webpack_public_path__ + "static/img/intro-pic3@3x.5d5b53a0.jpg";